export default function SellInInvoiceVsImeiScanCountTableBodyView() {

  const renderTableBody = (tableData) => {
    const { divisionGroupsNormalized, weeksASC } = tableData;

    const rows = [];

    const divisionGroupsASC = Object.keys(divisionGroupsNormalized).sort(
      (a, b) => a.localeCompare(b)
    );
    
    // the last total row of table as total division groups (except cell "Total")
    // init an array corresponding to week list to store 
    // count of all totalScanQty and all count of totalDoQty
    // [week1     , week2      , Total             , week3     ,...]
    // [[scan, do], [scan, do] , [scan, do, Total] , [scan, do],...]
    // [[0 , 0]   , [0, 0]     , [0, 0, Total]     , [0, 0 ]   ,...]
    // values will be added later inside inner loops
    let allDivisionGroupsWeeksScansAndDoQtyCol = Array.from(
      { length: weeksASC.length },
      () => [0, 0]
    );

    for (let divisionGroup of divisionGroupsASC) {
      const divisionNamesUniqueASC = Object.keys(
        divisionGroupsNormalized[divisionGroup]
      ).sort((a, b) => a.localeCompare(b));

      // The last row of each divisionGroup, same as allDivisionGroupsWeeksScansAndDoQtyCol
      let divisionMemberWeeksTotalScansAndDoQtyCol = Array.from(
        { length: weeksASC.length },
        () => [0, 0]
      );

      divisionNamesUniqueASC.forEach((dName, index) => {
        const tds = [
          index === 0 &&
          m("td.fw-bold",
            { rowspan: divisionNamesUniqueASC.length + 1, style: "--bs-table-hover-bg:transparent;" },
            divisionGroup
          ),
          m("td", dName),
        ];

        // store current sum of Scan and Do each time get into 
        // a week of a divisionName (member of division group)
        let divisionMemberWeeksTotalScansQtyRow = 0;
        let divisionMemberWeeksTotalDoQtyRow = 0;

        // store current sum of Scan and Do each time pass through  
        // all weeks of a divisionName (member of division group)
        let divisionMemberMonthsTotalScansQtyRow = 0;
        let divisionMemberMonthsTotalDoQtyRow = 0;

        weeksASC.forEach(({ week, month }, index) => {
          if (week === "Total") {
            const divisionNameMonthPercentage = calculateScanDoPercentage(
              divisionMemberWeeksTotalScansQtyRow,
              divisionMemberWeeksTotalDoQtyRow
            );

            divisionMemberWeeksTotalScansAndDoQtyCol[index][0] += divisionMemberWeeksTotalScansQtyRow;
            divisionMemberWeeksTotalScansAndDoQtyCol[index][1] += divisionMemberWeeksTotalDoQtyRow;
            divisionMemberWeeksTotalScansAndDoQtyCol[index][2] = "Total";

            allDivisionGroupsWeeksScansAndDoQtyCol[index][0] += divisionMemberWeeksTotalScansQtyRow;
            allDivisionGroupsWeeksScansAndDoQtyCol[index][1] += divisionMemberWeeksTotalDoQtyRow;
            allDivisionGroupsWeeksScansAndDoQtyCol[index][2] = "Total";

            divisionMemberWeeksTotalScansQtyRow = 0;
            divisionMemberWeeksTotalDoQtyRow = 0;

            tds.push(m("td", `${divisionNameMonthPercentage}%`));
          } else {
            const matched =
              divisionGroupsNormalized[divisionGroup][dName]?.[month]?.[week];

            const scanQty = Number(matched?.totalScanQty) || 0;
            const doQty = Number(matched?.totalDoQty) || 0;

            const divisionNameScanDoWeekPercentage = calculateScanDoPercentage(scanQty, doQty);

            divisionMemberWeeksTotalScansQtyRow += scanQty;
            divisionMemberWeeksTotalDoQtyRow += doQty;

            divisionMemberMonthsTotalScansQtyRow += scanQty;
            divisionMemberMonthsTotalDoQtyRow += doQty;

            divisionMemberWeeksTotalScansAndDoQtyCol[index][0] += scanQty;
            divisionMemberWeeksTotalScansAndDoQtyCol[index][1] += doQty;

            allDivisionGroupsWeeksScansAndDoQtyCol[index][0] += scanQty;
            allDivisionGroupsWeeksScansAndDoQtyCol[index][1] += doQty;

            tds.push(m("td", `${divisionNameScanDoWeekPercentage}%`));
          }
        });

        const divisionNameScanDoMonthsPercentage = calculateScanDoPercentage(
          divisionMemberMonthsTotalScansQtyRow,
          divisionMemberMonthsTotalDoQtyRow
        );

        tds.push(m("td", `${divisionNameScanDoMonthsPercentage}%`));

        divisionMemberMonthsTotalScansQtyRow = 0;
        divisionMemberMonthsTotalDoQtyRow = 0;

        rows.push(m("tr", tds));
      });

      const divisionGroupTds = [m("td.fw-bold", `${divisionGroup} Total`)];

      for (let [scanQty, doQty] of divisionMemberWeeksTotalScansAndDoQtyCol) {
        const divisionGroupScanDoWeekPercentage = calculateScanDoPercentage(
          scanQty,
          doQty
        );
        divisionGroupTds.push(m("td", `${divisionGroupScanDoWeekPercentage}%`));
      }

      let divisionGroupTotalSumScanQtyVSDoQty = [0, 0];
      for (let item of divisionMemberWeeksTotalScansAndDoQtyCol) {
        // only count if item in array stores total of week ("Total")
        if (item[2]) {
          divisionGroupTotalSumScanQtyVSDoQty[0] += item[0];
          divisionGroupTotalSumScanQtyVSDoQty[1] += item[1];
        }
      }

      const divisionGroupTotalMonthsPercent = calculateScanDoPercentage(
        divisionGroupTotalSumScanQtyVSDoQty[0],
        divisionGroupTotalSumScanQtyVSDoQty[1]
      );

      divisionGroupTds.push(m("td", `${divisionGroupTotalMonthsPercent}%`));

      rows.push(m("tr", { style: "background:#e9ecef;" }, divisionGroupTds));

      // reset before go to next group
      divisionMemberWeeksTotalScansAndDoQtyCol = Array.from(
        { length: weeksASC.length },
        () => [0, 0]
      );
    }

    const allDivisionGroupsTds = [m("td", { colspan: 2 }, "Total")];

    for (let [scanQty, doQty] of allDivisionGroupsWeeksScansAndDoQtyCol) {
      const percent = calculateScanDoPercentage(scanQty, doQty);
      allDivisionGroupsTds.push(m("td", `${percent}%`));
    }

    let allDivisionGroupsTotalSumScanQtyVSDoQty = [0, 0];
    for (let item of allDivisionGroupsWeeksScansAndDoQtyCol) {
      if (item[2]) {
        allDivisionGroupsTotalSumScanQtyVSDoQty[0] += item[0];
        allDivisionGroupsTotalSumScanQtyVSDoQty[1] += item[1];
      }
    }

    const totalPercentage = calculateScanDoPercentage(
      allDivisionGroupsTotalSumScanQtyVSDoQty[0],
      allDivisionGroupsTotalSumScanQtyVSDoQty[1]
    );

    allDivisionGroupsTds.push(m("td", `${totalPercentage}%`));

    rows.push(m("tr", { style: "background: #ced4da;" }, allDivisionGroupsTds));

    return m("tbody", rows);
  };

  function calculateScanDoPercentage(scanQyt, doQty) {
    return scanQyt && doQty ? ((scanQyt / doQty) * 100).toFixed(2) : Number(0).toFixed(2);
  }

  return {
    view: (vnode) => {
      return renderTableBody(vnode.attrs.tableData)
    }
  }
}